module.exports = __webpack_public_path__ + "static/media/dutchie_bw.1418989c.png";